import { render, staticRenderFns } from "./product_cost_detail.vue?vue&type=template&id=dfe54e10&scoped=true&"
import script from "./product_cost_detail.vue?vue&type=script&lang=js&"
export * from "./product_cost_detail.vue?vue&type=script&lang=js&"
import style0 from "./product_cost_detail.vue?vue&type=style&index=0&id=dfe54e10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe54e10",
  null
  
)

export default component.exports